import asicflow_logo from '../assets/img/logos/asicflow_logo.png'
import { Link } from 'react-router-dom'
import { useState } from 'react';
import {api} from '../../api.js'


function Signup(){

    const [firstname, setName] = useState('');
    const [familyname, setfName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPw] = useState('');
    const [msg, setMsg] = useState('');
    const [msgType, setMsgType] = useState('error'); // 'success' | 'error'
    const [agreed, setAgreed] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);


    const onSubmit = async e => {
        e.preventDefault();
        const { ok, data } = await api.register({ email,password,firstname,familyname });
        if (ok) {
          setMsgType('success');
          setMsg("Signup received. You will get an email soon.");
        } else {
          setMsgType('error');
          setMsg(data?.message || data?.error || "Unknown error");
        }
    }
    const handleAcceptTerms = () => {
        setAgreed(true);
        setShowTermsModal(false);
    };

    return(
      <>
      <section className="bg-secondary py-3 py-md-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
              <div className="card border border-light-subtle rounded-3 shadow-sm">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <div className="text-center mb-3">
                    <Link to="/">
                      <img
                        src={asicflow_logo}
                        alt="AsicFlow Logo"
                        width={300}  
                      />
                    </Link>
                  </div>
                  <h2 className="fs-6 fw-normal text-center text-secondary mb-4">
                    Enter your details to register
                  </h2>
                  
                  {/* Message Display Area */}
                  {msg && (
                    <div
                      className={`alert alert-${msgType === 'success' ? 'success' : 'danger'} alert-dismissible fade show`}
                      role="alert"
                    >
                      {msg}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setMsg('')}
                        aria-label="Close"
                      ></button>
                    </div>
                  )}
                  
                  <form>
                    <div className="row gy-2 overflow-hidden">
                      <div className="col-12">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            id="firstName"
                            placeholder="First Name"
                            required
                            value={firstname}
                            onChange={e => setName(e.target.value)}
                          />
                          <label htmlFor="firstName" className="form-label">
                            First Name
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            id="lastName"
                            placeholder="Last Name"
                            required
                            value={familyname}
                            onChange={e => setfName(e.target.value)}
                          />
                          <label htmlFor="lastName" className="form-label">
                            Last Name
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating mb-3">
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            placeholder="name@example.com"
                            required
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                          />
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating mb-3">
                          <input
                            type="password"
                            className="form-control"
                            name="password"
                            id="password"
                            placeholder="Password"
                            required
                            value={password}
                            onChange={e => setPw(e.target.value)}
                          />
                          <label htmlFor="password" className="form-label">
                            Password
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="iAgree"
                            id="iAgree"
                            required
                            checked={agreed}
                            onChange={e => setAgreed(e.target.checked)}
                          />
                          <label
                            className="form-check-label text-secondary"
                            htmlFor="iAgree"
                          >
                            I agree to the{" "}
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setShowTermsModal(true);
                              }}
                              className="link-primary text-decoration-none"
                            >
                              terms and conditions
                            </a>
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="d-grid my-3">
                          <button className="btn btn-primary btn-lg" type="button"  onClick={onSubmit}>
                            Sign up
                          </button>
                        </div>
                      </div>
                      <div className="col-12">
                        <p className="m-0 text-secondary text-center">
                          Already have an account?{" "}
                          <Link to="/login" className="link-primary text-decoration-none">
                            Sign in
                          </Link>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Terms and Conditions Modal */}
      {showTermsModal && (
        <div 
          className="modal fade show" 
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={() => setShowTermsModal(false)}
        >
          <div 
            className="modal-dialog modal-dialog-scrollable modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Terms and Conditions</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowTermsModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <h6>1. Acceptance of Terms</h6>
                <p>By accessing and using AsicFlow, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our service.</p>

                <h6>2. Description of Service</h6>
                <p>AsicFlow provides ASIC (Application-Specific Integrated Circuit) design and workflow management tools. We reserve the right to modify, suspend, or discontinue any part of our service at any time.</p>

                <h6>3. User Accounts</h6>
                <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to accept responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.</p>

                <h6>4. User Conduct</h6>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the service for any illegal purposes</li>
                  <li>Interfere with or disrupt the service or servers</li>
                  <li>Attempt to gain unauthorized access to any part of the service</li>
                  <li>Upload malicious code, viruses, or any harmful content</li>
                  <li>Violate any intellectual property rights</li>
                  <li>Share your account credentials with others</li>
                </ul>

                <h6>5. Intellectual Property</h6>
                <p>All content, features, and functionality of AsicFlow, including but not limited to software, designs, text, graphics, and logos, are owned by AsicFlow and are protected by international copyright, trademark, and other intellectual property laws.</p>

                <h6>6. User Content</h6>
                <p>You retain all rights to the design files and content you upload to AsicFlow. By uploading content, you grant us a license to use, store, and process your content solely for the purpose of providing our services to you.</p>

                <h6>7. Privacy and Data Protection</h6>
                <p>Your use of AsicFlow is also governed by our Privacy Policy. We are committed to protecting your personal information and will handle your data in accordance with applicable data protection laws.</p>

                <h6>8. Service Availability</h6>
                <p>While we strive to provide continuous service, we do not guarantee that AsicFlow will be available at all times. We may experience hardware, software, or other problems that could lead to service interruptions, delays, or errors.</p>

                <h6>9. Limitation of Liability</h6>
                <p>AsicFlow and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service. This includes but is not limited to loss of data, loss of profits, or business interruption.</p>

                <h6>10. Indemnification</h6>
                <p>You agree to indemnify and hold harmless AsicFlow, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses arising out of your use of the service or violation of these terms.</p>

                <h6>11. Termination</h6>
                <p>We reserve the right to terminate or suspend your account at any time, with or without notice, for conduct that we believe violates these Terms and Conditions or is harmful to other users, us, or third parties.</p>

                <h6>12. Modifications to Terms</h6>
                <p>We reserve the right to modify these Terms and Conditions at any time. We will notify users of any material changes. Your continued use of AsicFlow after such modifications constitutes your acceptance of the updated terms.</p>

                <h6>13. Governing Law</h6>
                <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of the jurisdiction in which AsicFlow operates, without regard to its conflict of law provisions.</p>

                <h6>14. Contact Information</h6>
                <p>If you have any questions about these Terms and Conditions, please contact us at support@asicflow.com.</p>

                <p className="text-muted mt-4"><small>Last Updated: December 2025</small></p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowTermsModal(false)}
                >
                  Close
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleAcceptTerms}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>

    );
}

export default Signup;